<!-- <div mat-dialog-title>{{message}}</div>
<mat-dialog-content style="width: 100px; height: 100px;">
    <mat-spinner class="center" style="margin-top: 20px; margin-bottom: 20px"></mat-spinner>
</mat-dialog-content> -->
<div class="title" style="margin-top: 10px;">{{message}}</div>

<mat-dialog-content  style="width: 100px; height: 100px;">
  <mat-spinner class="center" style="margin-top: 10px; margin-bottom: 20px"></mat-spinner>
</mat-dialog-content>